import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { campaignSearchSchema } from '@/shared/analytics/campaign-search'
import GtmLandingPage from '@/pages/gtm-landing'
import { buildHead } from '@/shared/seo/seo-config'

const searchSchema = campaignSearchSchema.extend({
  run: z.string().uuid().optional().catch(undefined),
})

export const Route = createFileRoute('/')({
  staticData: { layout: 'public' },
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: ({ search }) => {
    if (search.run) {
      throw redirect({
        to: '/$lang/gtm/$runId',
        params: { lang: 'en', runId: search.run },
        search: { checkout: undefined },
        replace: true,
      })
    }
  },
  head: () => buildHead('landing', 'en'),
  component: GtmLandingPage,
})
